import React, { useEffect, useState } from 'react';
import { DashboardApis } from 'hooks/apis/DashboardApis';
import { IClientTileProps } from 'interfaces/Dashboard/IClientTileProps';
import StatTile from '../../../components/common/StatTile';

const ClientAverageTatTile = ({clientReference, limsDatabase}: IClientTileProps) => {
  const [value, setValue] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { getClientAverageTat } = DashboardApis();

  useEffect(() => {
    getClientAverageTat(clientReference, limsDatabase)
      .then((data) => {
        if (data && !data.errorMessage) {
          setValue(data);
        } else if (data?.errorMessage) {
          setError(data.errorMessage);
        }
      })
      .finally(() => setLoading(false));
  }, [getClientAverageTat, clientReference, limsDatabase]);

  return (
    <StatTile
      label="Average TAT"
      value={value !== null ? value.toFixed(1) : '-'}
      suffix=" days"
      loading={loading}
      error={error}
    />
  );
};

export default ClientAverageTatTile;